export default __webpack_public_path__ + "static/media/Arrow.a682edf7.svg";